// Este arquivo é a nossa única fonte da verdade para as cores.
export const colors = {
  branco: '#FFFFFF',
  cinza: {
    background: '#F7F7F7',
    escuro: '#9E9E9E',
    desativado: '#C0C0C0',
  },
  verde: {
    fraco: '#D9FFEC',
    realce: '#21BA45',
    claro: '#278F54',
    medio: '#006634',
    escuro: '#064420',
  },
  vermelho: {
    delete: '#D30A0A',
  },
};